import { BrandColorsItemTypes } from './types';

import cn from './styles.module.css';

const BrandColorsItem = ({ title, color, setValue }: BrandColorsItemTypes) => (
  <div className={cn.brandColorsItem}>
    <div className={cn.brandColorsItemTitle}>{title}</div>
    <div className={cn.brandColorPicker}>
      <label className={cn.brandColorPickerButton} htmlFor="colorPicker">
        <div className={cn.brandColorExample} style={{ background: color }} />

        <div className={cn.brandColorHex}>{color?.toLocaleUpperCase()}</div>
        <input
          type="color"
          value={color}
          className={cn.brandColorPickerInput}
          id="colorPicker"
          onChange={(e) => setValue('brandColor', e.target.value)}
        />
      </label>
    </div>
  </div>
);

export default BrandColorsItem;
